import React, {useState, useEffect} from 'react'
import axios from 'axios'
import logo2 from './logo.png';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';


function Login(){
    const [username, setUsername] = useState('')

    const [password, setPassword] = useState('')

    const[submit, setSubmit] = useState('')

    const navigate = useNavigate();

  const handleSubmit = (event) => {
    event.preventDefault();
    // Handle form submission logic...
    // Navigate to the dashboard after successful login
    navigate('/authorpush'); 
  };  

    


    //const submitEntry =() =>{}

   //  useEffect(()=>
   // {
    //    axios.get('https://jtvetapi.onrender.com/entries')
    //    .then(res=>setEntries(res.data))
        
        
   // }, [])

  //  const submitEntry = () =>{ 
   //     axios.post('https://jtvetapi.onrender.com/entries', {title, author, date, doi})
     //   .then(()=>window.location.reload())
  //  }


return(
    
    <div className="App"
    
    
    >
         <img src={logo2}  alt="logo" />
        <h1>Journal of Technical and Vocational Education and Training</h1>
        <h2>Welcome Author!</h2>
        <p><i>Enter Login details below in order to submit an article</i></p>
        <form className=''>
         <input className='input' value ={username} onChange={e=>setUsername(e.target.value)} placeholder='Username'/>
        <br/>
        <input className='input' type="password" value ={password} onChange={e=>setPassword(e.target.value)} placeholder="Password"/>
        <br/>

        <br/>
        <button className='button' type="submit" onClick={handleSubmit}>Login</button>
        <p>Not a registered Author? Do that  <Link to="/register">here</Link></p>
        
        </form>
       <footer><small>Copyright &copy; 2026 Designed by | ISITEC</small></footer>
    </div>

)
}

export default Login